import React from 'react';

export default function MyProfiles() {
    return <h1>MyProfiles</h1>;
}
